<template>
    <div class="newPage">
        <div class="content">
            <div class="reportRow">
                <el-row>
                    <el-col :span="7">
                        <el-select v-model="params.type" placeholder="请选择" size="mini">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="手动报告" :value="2"></el-option>
                            <el-option label="自动报告" :value="4"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="7">
                        <el-date-picker
                                v-model="params.startTime"
                                size="mini"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择开始时间">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="7">
                        <el-date-picker
                                v-model="params.endTime"
                                size="mini"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择结束时间">
                        </el-date-picker>
                    </el-col>

                    <el-col :span="2">
                        <el-button size="mini" type="primary" @click="getWordTemplategenerateList"> 查询</el-button>
                    </el-col>
                </el-row>
            </div>
            <div class="HistoryList">
                <el-table
                        v-loading="loading"
                        :data="historyList.list"
                        stripe
                >
                    <el-table-column
                            label="序号"
                            align="center"
                            type="index"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="操作模块"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.type===2">VOC系统 - 综合分析</div>
                            <div v-if="scope.row.type===4">VOC系统 - 定时报告</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="title"
                            align="center"
                            label="标题"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="createTime" align="center"
                            label="时间">
                        <template slot-scope="scope">
                            <div>{{scope.row.createTime | YearDate}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="createUserName" align="center"
                            label="操作者">
                    </el-table-column>
                    <el-table-column
                            width="330"
                            prop="address" align="center"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="jump(scope.row)">查看</el-button>
                            <el-button size="mini" @click="deleteItem(scope.row)">删除</el-button>
                            <el-button size="mini" @click="download(scope.row,1)">下载 word</el-button>
                            <el-button size="mini" @click="download(scope.row,2)">下载 pdf</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination
                        v-show="historyList.totalCount>0"
                        :total="historyList.totalCount"
                        :page.sync="params.page"
                        :limit.sync="params.pageSize"
                        @pagination="getWordTemplategenerateList"
                />
            </div>

        </div>
    </div>
</template>

<script>

    import url from "../../../utils/UrlApi"

    function params(obj) {
        let result = '';
        let item;
        for (item in obj) {
            if (obj[item] && String(obj[item])) {
                result += `&${item}=${obj[item]}`;
            }
        }
        if (result) {
            result = '?' + result.slice(1);
        }
        return result;
    }

    export default {
        name: "VOCHistory",
        components: {},
        data() {
            return {
                historyList: {
                    currPage: 1,
                    list: [],
                    pageSize: 0,
                    totalCount: 0,
                    totalPage: 0,
                },
                params: {
                    page: 1,
                    pageSize: 10,
                    type: '',
                    startTime: '',
                    endTime: '',
                },
                loading: false
            }
        },
        created() {
            this.getWordTemplategenerateList()
        },
        methods: {
            getWordTemplategenerateList() {
                let data = this.params
                this.loading = true
                this.$http.get(url.wordTemplategenerateList, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        // this.historyList.list.length > 0 ? this.historyList.list = this.historyList.list.concat(res.data.data.list) : this.historyList = res.data.data
                        this.historyList = res.data.data
                        this.loading = false
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            jump(item) {
                if (item.type === 2) {
                    this.$router.push({name: 'VOCcomReport', query: {para: item.para}})
                }
                if (item.type === 4) {
                    this.$router.push({name: 'VOCexistingReport', query: {para: item.para, reportId: item.id}})
                }
            },
            load() {
                console.log('chudi')
                if (this.historyList.totalPage > this.params.page) {
                    this.params.page++
                    this.getWordTemplategenerateList()
                }
            },
            deleteItem(item, index) {
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    let data = {
                        id: item.id
                    }

                    this.$http.post(url.wordTemplatedelete, data).then(res => {
                        if (res.data.code === '200') {
                            this.getWordTemplategenerateList()
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }).catch(() => {
                });
            },

            download(item, type) {
                let data = {
                    id: item.id,
                    type: type,
                    token: localStorage.getItem('token')
                }
                let allUrl = url.wordTemplatedownload + params(data)
                window.open(allUrl, '_blank')
            }
        }
    }
</script>

<style scoped lang="less">

    .HistoryList {

        width: 80%;
        min-width: 550px;
        margin: 0 auto;
        padding: 10px;
        border-left: 1px solid #ddd;
        border-right: 1px solid #ddd;
        background-color: #fff;

        .HistoryItem {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .histyTimer {

            }
            .histyIcon {
                background-color: #1b486f;
                border-radius: 50%;
                margin: 0 20px;

                img {
                    width: 20px;
                    height: 20px;
                }

            }
            .histyName {

                flex: 1;
            }
            .histyOther {

            }
        }
        :last-child {
            margin-bottom: 0;
        }
    }

    .reportRow {
        padding: 10px 0;
        border-bottom: 1px solid #ddd;
        width: 80%;
        margin: 0 auto 10px auto;
        .reportRowBtn {
            float: right;
        }
    }
</style>